module.exports = __webpack_public_path__ + "static/media/mic-record.fcd0b9a4.svg";